// @flow
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const SVG_PHYS_WIDTH = 46;
const SVG_PHYS_HEIGHT = 46;
const SVG_APPARENT_WIDTH = 30;
const SVG_APPARENT_HEIGHT = 30;

const hatch = color => (
  <path
    fill={color}
    d={
      'M8,18.79l-8,8v-1l8-8Zm0-4.3-8,8v1l8-8Zm0-3.28-8,8v1l8-8ZM8,8h.94' +
      'l8-8h-1L0,15.92v1l8-8ZM8,34.21l-8,8v1l8-8ZM12.63,0,0,12.63v1L13.65,0Z' +
      'M8,27.63l-8,8v1l8-8ZM9.35,0,0,9.35v1L10.37,0ZM8,21.06l-8,8v1l8-8Z' +
      'm0,3.29-8,8v1l8-8ZM12.22,8l8-8h-1l-8,8ZM25.37,8l8-8h-1l-8,8Z' +
      'M22.08,8l8-8h-1l-8,8Zm6.57,0,8-8h-1l-8,8ZM6.06,0,0,6.06v1L7.08,0Z' +
      'M31.94,8l8-8h-1l-8,8Zm3.28,0,8-8h-1l-8,8ZM2.78,0,0,2.78v1L3.79,0Z' +
      'M0,0V.51L.51,0ZM8,38v-.51l-8,8V46H.51l8-8ZM15.51,8l8-8h-1l-8,8Z' +
      'm3.28,0,8-8h-1l-8,8ZM8,30.92l-8,8v1l8-8Zm30-2.7,8-8v-1l-8,8Z' +
      'm0-3.28,8-8v-1l-8,8Zm0,6.57,8-8v-1l-8,8Zm0,3.28,8-8v-1l-8,8Z' +
      'M38,38h-.94l-8,8h1L46,30.08v-1l-8,8ZM45.49,0l-8,8H38v.51l8-8V0Z' +
      'M38,11.79l8-8v-1l-8,8ZM33.37,46,46,33.37v-1L32.35,46ZM38,18.37' +
      'l8-8v-1l-8,8Zm0-3.29,8-8v-1l-8,8Zm0,6.57,8-8v-1l-8,8ZM30.49,38l-8,8' +
      'h1l8-8Zm-3.28,0-8,8h1l8-8Zm9.44,8L46,36.65v-1L35.63,46ZM23.92,38l-8,8' +
      'h1l8-8Zm-6.57,0-8,8h1l8-8Zm-3.29,0-8,8h1l8-8Zm6.57,0-8,8h1l8-8Z' +
      'm22.59,8L46,43.22v-1L42.21,46Zm-3.28,0L46,39.94v-1L38.92,46ZM46,46' +
      'v-.51l-.51.51ZM10.78,38l-8,8h1l8-8Zm23,0-8,8h1l8-8Z'
    }
  />
);

const Rect = props => (
  <rect
    width={SVG_PHYS_WIDTH}
    height={SVG_PHYS_HEIGHT}
    fill="transparent"
    {...props}
  />
);

export default ({ color, hatched = false, dashed = false }) => (
  <SvgIcon
    style={{ width: SVG_APPARENT_WIDTH, height: SVG_APPARENT_HEIGHT }}
    viewBox={`0 0 ${SVG_PHYS_WIDTH} ${SVG_PHYS_HEIGHT}`}
  >
    <Rect fill="white" />
    {hatched ? (
      hatch(color)
    ) : (
      <Rect stroke={color} strokeWidth="17" strokeOpacity=".2" />
    )}
    <Rect stroke="white" strokeWidth="10" />
    <Rect
      stroke={color}
      strokeWidth="6"
      strokeDasharray={dashed ? '3,3' : ''}
    />
  </SvgIcon>
);



// WEBPACK FOOTER //
// ./components/MapLayerDrawer/MapLayerIcon.js